export default __webpack_public_path__ + "static/media/vehicle0.ccbe83cf.svg";